<template>
    <div class="top-bar-nine">
        <div class="container">
            <div class="top-bar-nine-all">
                <div class="navbar-header">
                    <router-link class="navbar-brand logo" to="/home/index-9">
                        <img src="@/assets/img/logo.svg" class="img-fluid" alt="Logo">
                    </router-link>
                </div>
                <div class="top-bar-ryt">
                    <div class="top-address">
                        <span><i class="feather-phone-call"></i></span>
                        <div>
                            <h6>Get Support</h6>
                            <p>310-437-2766</p>
                        </div>
                    </div>
                    <div class="top-address">
                        <span><img src="@/assets/img/icons/global-nine.svg" alt="image"></span>
                        <div class="top-addres-nine">
                            <h6>Language</h6>
                            <p>
                                <img src="@/assets/img/icons/dropdown-nine.svg" class="footer-dropdown" alt="img">
                                <select class="top-select">
										<option>English</option>
										<option>Mexico</option>
										<option>American</option>
									</select>
                            </p>
                        </div>
                    </div>
                    <div class="top-btn">
                        <router-link to="/" class="btn btn-primary"><i class="feather-user"></i> Login</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
}
</script>